import { EnvironmentConfigItem } from "./models/environment-config.model";
import { EnvironmentNames } from "./models/environment-names.enum";

export function getEnvironments(... environmentKey: EnvironmentNames[]) : EnvironmentConfigItem[] {
  return environmentConfigItems.filter(x => environmentKey.find(key => x.envKey == key));
}
export function getEnvironment(environmentKey: EnvironmentNames) : EnvironmentConfigItem {
  return environmentConfigItems.find(x => x.envKey == environmentKey);
}

export const environmentConfigItems: EnvironmentConfigItem[] = [
    {
      envKey: EnvironmentNames.enterprise,
      envMessage: 'Ent - Local',
      apiRoot: "https://localhost:44368/api/v1",
      stripePublicKey: "pk_test_51PtXdVRvgfUzg9zpJzvEDuaMoSMHAhz4CRU3RMTCzfN89Rl44UYlPyk8gfzp9X6hsRkCEjturKdlpHvrDOXxrgSu00fPYTuMq3",
    }, 
    {
      envKey: EnvironmentNames.test,
      envMessage: 'Test',
      apiRoot: "https://aviator-online-test-api4.azurewebsites.net/api/v1",
      useCDN: true,
      cdnRoot: 'https://aviator-online-test-api4.b-cdn.net/api/v1',
      stripePublicKey: "pk_test_51PtXdVRvgfUzg9zpJzvEDuaMoSMHAhz4CRU3RMTCzfN89Rl44UYlPyk8gfzp9X6hsRkCEjturKdlpHvrDOXxrgSu00fPYTuMq3",
    },
    {
      envKey: EnvironmentNames.testlocal,
      envMessage: 'TestLocal',
      apiRoot: "https://localhost:44373/api/v1",
      useCDN: false,
      cdnRoot: 'https://aviator-online-test-api4.b-cdn.net/api/v1',
      stripePublicKey: "pk_test_51PtXdVRvgfUzg9zpJzvEDuaMoSMHAhz4CRU3RMTCzfN89Rl44UYlPyk8gfzp9X6hsRkCEjturKdlpHvrDOXxrgSu00fPYTuMq3",
      //stripePublicKey: "pk_live_51PtXdVRvgfUzg9zpUv7D1xe6wJfwF8qlzhgIa54JJ0PWndeMNgDUv8nMWs8pu9DosPQtrpYzacqZPEq8bn1mVh2b00epYm0jhX",
    },
    {
      envKey: EnvironmentNames.stage,
      envMessage: 'Stage',
      hostNameMatch : 'staging.aviatorpro.com',
      apiRoot: "https://aviator-online-prod-api-stage.azurewebsites.net/api/v1",
      useCDN: false,
      cdnRoot: "https://aviator-online-prod-api-stage.b-cdn.net/api/v1",
      stripePublicKey: "pk_test_51PtXdVRvgfUzg9zpJzvEDuaMoSMHAhz4CRU3RMTCzfN89Rl44UYlPyk8gfzp9X6hsRkCEjturKdlpHvrDOXxrgSu00fPYTuMq3",
    },
    {
      envKey: EnvironmentNames.prod,
      envMessage: '',
      apiRoot: "https://aviator-online-prod-api.azurewebsites.net/api/v1",
      useCDN: true,
      //cdnRoot: "https://aviator-online-prod.azureedge.net/api/v1",
      // Move to Bunny.net CDN
      cdnRoot: "https://aviator-online-prod-api.b-cdn.net/api/v1",
      stripePublicKey: "pk_live_51PtXdVRvgfUzg9zpUv7D1xe6wJfwF8qlzhgIa54JJ0PWndeMNgDUv8nMWs8pu9DosPQtrpYzacqZPEq8bn1mVh2b00epYm0jhX",
    },
  ];
  